import { render, staticRenderFns } from "./grading-definition.vue?vue&type=template&id=909fdf66&scoped=true&"
import script from "./grading-definition.vue?vue&type=script&lang=js&"
export * from "./grading-definition.vue?vue&type=script&lang=js&"
import style0 from "./grading-definition.vue?vue&type=style&index=0&id=909fdf66&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "909fdf66",
  null
  
)

export default component.exports